<template>
  <div v-if="show">
    <div class="tw-document-wrapper z-top controls-background">
      <div>
        <div class="card-header bg-white d-flex justify-content-between align-items-center  pl-3 pr-2">
          <div class="card-title mb-0 d-flex align-items-center">
            <span class="font-weight-bold">{{ `${$t("printDocument.reference")}: ${reference}` }} </span>
          </div>
          <div class="card-title mb-0 d-flex align-items-end">
            <q-icon name="chevron_right" size="20px" @click="toggleShowControls" />
          </div>
        </div>
        <div class="row card-body tw-document-container">
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <PrintDocumentList class="q-mr-md" :reference="reference"/>
              </div>
              <div class="col-6">
                <PrintDocumentPreview :reference="reference" />
              </div>
            </div>
          </div>
          <div class="col-12">
            <PrintDocumentSender v-if="showSendTemplate" />
          </div>
        </div>
        <PrintDocumentConfirmationDialog :show="dialogState && show" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import store from "@/store";
import PrintDocumentPreview from "@/components/document/PrintDocumentPreview.vue";
import PrintDocumentList from "@/components/document/list/PrintDocumentList.vue";
import PrintDocumentActions from "@/components/document/list/PrintDocumentActions.vue";
import PrintDocumentConfirmationDialog from "@/components/document/PrintDocumentConfirmationDialog.vue";
import PrintDocumentSender from "@/components/document/list/PrintDocumentSender.vue";

@Options({
  components: {
    PrintDocumentSender,
    PrintDocumentPreview,
    PrintDocumentList,
    PrintDocumentActions,
    PrintDocumentConfirmationDialog,
  }
})
export default class PrintDocumentDialog extends Vue {
  get show() {
    return store.state.printDocumentModule.show
  }

  get showSendTemplate() {
    return store.state.printDocumentModule.showSendTemplate;
  }

  get reference() {
    switch (this.currentRoute) {
      case "order-edit": {
        return store.state.orderModule.order?.reference
      }
      case "TaskDetail": {
        const entityType = store.getters['taskModule/isTaskModuleOffer'] ? 'offer' : 'order'
        if (entityType === 'offer') {
          return store.state.taskModule.offer?.reference
        } else {
          return store.state.taskModule.order?.reference
        }
      }
      case "demand-edit": {
        return store.state.demandModule.offer?.reference
      }
      case "third-edit": {
        return store.state.thirdModule.third?.person?.reference
      }
    }
    return '-'
  }

  get dialogState() {
    return store.state.printDocumentModule.printDocumentConfirmationDialogState
    && store.state.printDocumentModule.printDocumentConfirmationDialogState.show
  }

  toggleShowControls() {
    return store.dispatch('printDocumentModule/toggleShow')
  }

  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }

  created() {
    store.dispatch("printDocumentModule/getTemplates", {
      currentRoute: this.currentRoute
    });
  }

}
</script>

<style scoped>
.controls-background {
  background-color: white;
  border-radius: 10px;
  -webkit-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
}

</style>
